export default function (editor, opts = {}) {
  const { type, label, category, collections } = opts;
  const subTenantCollection =
    collections && collections.find((collection) => !!collection.isSubTenantCollection);
  const subTenantCollectionTitle = subTenantCollection ? subTenantCollection.collectionTitle : '';
  const bm = editor.BlockManager;

  bm.add('sub-tenant-dropdown', {
    label: `
      <svg class="gjs-block-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path class="gjs-block-svg-path" d="M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z" fill-rule="nonzero"></path>
        <rect class="gjs-block-svg-path" x="15" y="10" width="5" height="1"></rect>
        <rect class="gjs-block-svg-path" x="15" y="13" width="5" height="1"></rect>
        <rect class="gjs-block-svg-path" x="15" y="11.5" width="5" height="1"></rect>
      </svg>
      <div class="gjs-block-label">${label}</div>`,
    category: category,
    content: `
      <li class="nav-item dropdown" data-gjs-type="${type}" data-js="${type}" data-gjs-custom-name="${label}" style="display: inline-block">
        <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-gjs-custom-name="${
          opts.labels.labelNavItemSubMenuToggle
        }"
        data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false"
        data-gjs-selectable="false" data-gjs-highlightable="false"
        >
        <span data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false"
        >${subTenantCollectionTitle ? subTenantCollectionTitle : 'Sub Tenants'}</span>
        </a>
        <ul class="dropdown-menu" data-gjs-type="${opts.types.nav_item_dropdown_menu}">
          <a data-gjs-type="link-box" class="dropdown-item" href="#" 
          data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false" 
          data-gjs-selectable="false" data-gjs-highlightable="false"
          >${subTenantCollectionTitle ? subTenantCollectionTitle : 'Sub Tenant'} 1</a>
        </ul>
      </li>
      `,
    render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>
    `,
  });
}
